import { createContext } from "react";

export const RubrosContext = createContext()
export const RubrosFormContext = createContext()
export const RubrosReportContext = createContext()